import {View} from 'react-native';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import GrpReferralRefive from 'src/components/img/svg/GrpReferralRefive';
import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';

export function getReferralStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    referralTitle: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m3,
      fontSize: Styles.Fonts.f3,
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.figtreeRegular,
      color: Styles.Colors.Refive.navy,
    },
    referralDesc: {
      marginTop: Styles.Spacing.m2 + Styles.Spacing.m1,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.figtreeRegular,
      color: Styles.tabBarTextColor,
    },
    referralExpiry: {
      marginTop: Styles.Spacing.m3,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      textAlign: 'center',
      fontStyle: 'italic',
      fontFamily: Styles.FontFamily.figtreeRegular,
      color: Styles.Colors.Refive.activeFooterBlue,
    },
    totalReferralsKey: {
      fontSize: Styles.Fonts.f8,
      fontWeight: '400',
      textAlign: 'center',
      fontFamily: Styles.FontFamily.figtreeRegular,
      color: Styles.lightGray,
      lineHeight: 14,
    },
    totalReferralsValue: {
      fontSize: Styles.Fonts.f3,
      fontWeight: 'bold',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.figtreeRegular,
      color: Styles.tabBarTextColor,
    },
    shareViaEmailTitle: {
      fontSize: Styles.Fonts.f7,
      fontWeight: '400',
      textAlign: 'left',
      fontFamily: Styles.FontFamily.figtreeRegular,
      color: Styles.tabBarTextColor,
    },
    errorLabel: {
      color: Styles.dangerColor,
      fontSize: Styles.Fonts.f8,
      fontFamily: Styles.FontFamily.figtreeRegular,
      alignSelf: 'flex-start',
      marginHorizontal: Styles.Spacing.m3,
      marginTop: Styles.Spacing.m1,
    },
    orText: {
      fontSize: Styles.Fonts.f1,
      textTransform: 'uppercase',
      color: Styles.tabBarTextColor,
      fontFamily: Styles.FontFamily.figtreeRegular,
      marginHorizontal: Styles.Spacing.m3,
    },
  };
}

export function getReferralTitleMsg(
  amount: string,
  transactionMinimum?: string,
): string {
  return Localized.Labels.formatString(
    Localized.Labels.referral_invite_earn_desc,
    'Refive Market',
    transactionMinimum,
    amount,
  ).toString();
}

export function getReferralHeaderIcon() {
  return (
    <View style={{marginBottom: -Styles.Spacing.m3}}>
      <GrpReferralRefive width={101} height={100} />
    </View>
  );
}

export function getSendInviteButton(
  checkDisabled: () => boolean,
  callback: () => void,
) {
  return (
    <View
      style={{
        alignSelf: 'flex-end',
        marginVertical: Styles.Spacing.m3 + Styles.Spacing.m2,
      }}
    >
      <RoundedAppButton
        buttonType={RoundedAppButtonType.Solid}
        onPress={callback}
        isDisabled={checkDisabled()}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
        }}
        inActiveTextStyle={[
          {
            fontFamily: Styles.FontFamily.figtreeRegular,
            fontSize: Styles.Fonts.f1,
          },
        ]}
        textStyle={[
          {
            fontFamily: Styles.FontFamily.figtreeRegular,
            fontSize: Styles.Fonts.f1,
          },
        ]}
        accessibilityLabelValue="Send Invite"
        titleText={Localized.Buttons.send_invite}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      />
    </View>
  );
}

export default {
  getReferralStyles,
  getReferralTitleMsg,
  getReferralHeaderIcon,
  getSendInviteButton,
};
